import React from 'react';

import { useCustomerApi } from './api/useCustomerApi';
import { useAppStaticContext } from './AppContext';

export const useReferralCode = (friendType?: string, pageCode?: string) => {

  const { getReferralCode } = useCustomerApi();
  const { getFixedPagePath, getPagePath } = useAppStaticContext();

  const [referralCode, setReferralCode] = React.useState<string | undefined>(undefined);

  React.useEffect(() => {
    getReferralCode(friendType).then((response) => setReferralCode(response.data));
  }, [getReferralCode, friendType]);

  const referralLink = React.useMemo(() => {
    if (!referralCode) {
      return undefined;
    }

    const pagePath = pageCode && getPagePath(pageCode);
    const fixedPagePath = getFixedPagePath('register');
    
    const url = new URL( pagePath ?? fixedPagePath, window.location.origin);
  
    url.searchParams.append('referralCode', referralCode);
    return url.toString();
  }, [referralCode, pageCode, getPagePath, getFixedPagePath]);

  return { referralCode, referralLink };
};
